<header [class.authenticated]="isUserAuthenticated" [class.open]="sidebarOpen$ | async" [class.shadow]="applyShadow$ | async">
  <app-header-alert-banner></app-header-alert-banner>

  <div *ngIf="topBar.show" class="header-row row-top-bar">
    <span *ngIf="topBar.leftText" class="left-text" [innerHTML]="topBar.leftText | safe"></span>
    <span *ngIf="topBar.centerText" class="center-text" [innerHTML]="topBar.centerText | safe"></span>
    <span *ngIf="topBar.rightText" class="right-text" [innerHTML]="topBar.rightText | safe"></span>
  </div>

  <div class="header-row row-navigation">
    <a *ngIf="headerLogos.length === 0" class="logo-container" [href]="logoLink" [target]="logoLinkTarget" rel="noopener">
      <img [src]="logoUrl" [alt]="logoAlt">
    </a>

    <!-- Show icon buttons on left side only if header is type '2' (with logos) -->
    <div class="banner-buttons-container" *ngIf="headerLogos.length > 0">
      <opac-button class="auth-button banner-home-button" type="text" (click)="navigateHome()">
        <span>{{ 'general.home' | translate }}</span>
        <opac-icon icon="home"></opac-icon>
      </opac-button>

      <opac-button *ngIf="isBookClubEnabled" class="auth-button banner-bookclub-button" type="text" (click)="handleBookClubClick()">
        <span>{{ bookClubName }}</span>
      </opac-button>
    </div>

    <app-header-banners></app-header-banners>

    <!-- Show icon buttons on right side only if header is type '1' (without logos) -->
    <ng-container *ngIf="headerLogos.length === 0">
      <opac-button class="home-button" [ariaLabel]="'general.home' | translate" (click)="navigateHome()" [opacTooltip]="'general.home' | translate" dataTestId="header-home-button">
        <opac-icon icon="home" slot="only-icon"></opac-icon>
      </opac-button>

      <opac-button *ngIf="isBookClubEnabled" class="book-club-button" [ariaLabel]="bookClubName" [opacTooltip]="bookClubName" (click)="handleBookClubClick()" dataTestId="header-book-club-button">
        <opac-icon icon="bookclub" slot="only-icon"></opac-icon>
      </opac-button>
    </ng-container>

    <app-header-notifications-button *ngIf="isUserAuthenticated"></app-header-notifications-button>
    <app-header-events-button *ngIf="isUserAuthenticated && isEventsEnabled"></app-header-events-button>

    <opac-button *ngIf="!isUserAuthenticated" class="auth-button login-button" type="text" (click)="handleLogin()" [dataTestId]="'header-login-button'">
      {{ 'header.login' | translate }}
    </opac-button>

    <opac-button *ngIf="!isUserAuthenticated && isGuestLoginEnabled" class="auth-button guest-button" type="text" (click)="handleGuestLogin()" [dataTestId]="'header-guest-login-button'">
      {{ 'header.loginGuest' | translate }}
    </opac-button>

    <opac-button *ngIf="!isUserAuthenticated && isSignUpEnabled" class="auth-button signup-button" type="text" (click)="handleSignUp()" [dataTestId]="'header-register-button'">
      {{ 'header.register' | translate }}
    </opac-button>

    <app-header-help-button></app-header-help-button>

    <app-header-user-button></app-header-user-button>

    <opac-button class="search-button" [ariaLabel]="'tooltip.search' | translate" [opacTooltip]="'tooltip.search' | translate" (click)="handleSearchButton()" dataTestId="header-search-button">
      <opac-icon icon="search" slot="only-icon"></opac-icon>
    </opac-button>
  </div>

  <div *ngIf="headerLogos.length > 0" class="header-row row-banner-logos" [class.aula-madrid]="isAulaMadrid">
    <div *ngFor="let logo of headerLogos; let index = index">
      <img [src]="logo" [alt]="headerLogosAlt[index] !== undefined ? headerLogosAlt[index] : ''" [tabIndex]="headerLogosAlt[index] !== undefined ? 0 : -1">
    </div>
  </div>
</header>
